import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WA_LINK } from "@/components/Reveal";

export default function WhatsAppFloat() {
  return (
    <motion.a
      data-testid="floating-whatsapp-chat-button"
      href={WA_LINK}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Taste Ride on WhatsApp"
      initial={{ opacity: 0, scale: 0.6, y: 24 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 2, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ scale: 1.06 }}
      whileTap={{ scale: 0.95 }}
      className="group fixed bottom-5 right-5 z-[70] flex items-center gap-3 rounded-full bg-wa py-3.5 pl-4 pr-5 shadow-[0_12px_40px_rgba(37,211,102,0.45)] sm:bottom-7 sm:right-7"
    >
      <span className="relative flex h-2.5 w-2.5">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-obsidian/60 opacity-75" />
        <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-obsidian" />
      </span>
      <MessageCircle size={22} strokeWidth={2.4} className="text-obsidian" />
      <span className="hidden font-display text-sm font-semibold text-obsidian sm:inline">
        Chat with us
      </span>
    </motion.a>
  );
}
